import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-page28',
  templateUrl: './page28.component.html',
  styleUrls: ['./page28.component.css']
})
export class Page28Component implements OnInit {
  @Input() data: any;
  constructor() { }

  ngOnInit(): void {
  }

}
